import faker from '@faker-js/faker';

import {COINS} from '../../../constants';

import {TListItem} from './types';

export const apiV2CryptoAccountGet = (): TListItem => {
  const networks = ['Bitcoin', 'Etherium', 'Bitcom cash'];
  const statuses = ['active', 'inactive'];
  const coinsList = COINS.map((el) => el.id);
  return {
    id: faker.datatype.uuid(),
    network: (faker.helpers as any).arrayElement(networks),
    address: faker.datatype.uuid(),
    coin: (faker.helpers as any).arrayElement(coinsList),
    status: (faker.helpers as any).arrayElement(statuses)
  } as TListItem;
};
